import { makeStyles, Theme, createStyles } from "@material-ui/core";

export const payStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: { fontWeight: "bold", fontSize: 16, marginBottom: 10 },
    smallText: { fontSize: 10, marginTop: 15 },
  })
);
